/* eslint-disable complexity */
import { $Q, $Qll } from "../utils/query-selector"

/**
 * Open nodes with CSS and dataset
 * @param {String} node selector who detect click
 * @param {String} query selector with the node to open
 * @param {Object} config Obejct with attribute from config open
 *
 * @return {Function}
 */

 export const toggleDataActive = (node, parent, config) => {
  const { overlay, bodyBlocked } = config || { overlay: false }
  const toOpen = parent ? $Q(parent) : $Q(node)

  return $Qll(node).forEach((element) => {
    element.addEventListener(
      'click',
      () => {
        dataToggle(toOpen, overlay, bodyBlocked);
        if (element.classList.contains("cart-footer__button--close") && window.location.href.includes("abonnement-couches-bebe")) {
          // Redirection vers la page d'accueil
          window.location.href = '/';   
        }
      },
    )
  });
}

export function dataToggle(nodeToOpen, overlay = false, bodyBlocked = false) {
  const dataset = nodeToOpen.dataset.active
  const isActive = dataset == 'true'

  if (!dataset) return null

  if (!isActive) {
    nodeToOpen.dataset.active = 'true'
    if (bodyBlocked) document.body.style.overflow = 'hidden'
  } else {
    nodeToOpen.dataset.active = 'false'
    if (bodyBlocked) document.body.style.overflow = 'initial'
  }

  overlay && overlayActions({
    isActive,
    target: nodeToOpen,
    bodyBlocked,
  })
}

export const overlayActions = ({ isActive, target, bodyBlocked }) => {
  const id = target.getAttribute('id')

  if (!isActive) {
    const before = document.createElement('div')
    before.setAttribute('id', `overlay--${id}`)
    before.classList.add('overlay')
    target.parentNode.insertBefore(before, target)
    toggleDataActive(
      `#overlay--${id}`,
      `#${id}`,
      { overlay: true, bodyBlocked },
    )
  } else {
    target.parentNode.removeChild($Q(`#overlay--${id}`))
  }
}
